import axiosApiClient from "../axios";

const PATH = '/api/branch-admin';

export const getAllBranchAdmins = async () => {
    try {
        return await axiosApiClient.get(PATH);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get all branch admins');
    }
};

export const getBranchAdminById = async (id) => {
    try {
        return await axiosApiClient.get(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get branch admin by ID');
    }
};

export const getBranchAdminByUsername = async (username) => {
    try {
        return await axiosApiClient.get(`${PATH}/username/${username}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to get branch admin by username');
    }
};

export const createBranchAdmin = async (formData) => {
    try {
        return await axiosApiClient.post(PATH, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to create branch admin');
    }
};

export const updateBranchAdmin = async (id, formData) => {
    try {
        return await axiosApiClient.put(`${PATH}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to update branch admin');
    }
};

export const deleteBranchAdmin = async (id) => {
    try {
        return await axiosApiClient.delete(`${PATH}/${id}`);
    } catch (err) {
        throw new Error(err.response?.data?.message || 'Failed to delete branch admin');
    }
};
